import { ReactNode } from 'react';
import Pill, { PillTone } from '../ui/Pill';
import { showValue, stateLabel } from '../../services/reviewApi';

export const inputClass =
  'border border-line-strong rounded-sm bg-white px-3 py-[10px] min-h-[44px] text-table text-ink w-full';

export function Th({ children, className = '' }: { children?: ReactNode; className?: string }) {
  return (
    <th className={`font-semibold text-small text-ink-2 text-left py-[10px] px-[14px] ${className}`}>{children}</th>
  );
}

export function Td({ children, className = '' }: { children?: ReactNode; className?: string }) {
  return <td className={`px-[14px] py-[10px] align-top text-table ${className}`}>{children}</td>;
}

export function HeadRow({ children }: { children: ReactNode }) {
  return <tr className="bg-paper border-b border-line">{children}</tr>;
}

const STATE_TONES: Record<string, PillTone> = {
  needs_attestation: 'planned',
  not_started: 'planned',
  draft: 'running',
  reopened: 'running',
  submitted: 'healthy',
  withdrawn: 'inactive',
  conflict_declared: 'failed',
  proposed: 'planned',
  active: 'active',
  conflicted: 'failed',
  removed: 'inactive',
  eligible: 'healthy',
  flagged: 'failed',
  ineligible: 'inactive',
  pending: 'planned',
};

export function StatusPill({ status, label }: { status: string; label?: string }) {
  return <Pill tone={STATE_TONES[status] ?? 'inactive'}>{label ?? stateLabel(status)}</Pill>;
}

export function Field({ label, value, children }: { label: string; value?: unknown; children?: ReactNode }) {
  return (
    <div className="py-[7px] border-b border-line grid grid-cols-[200px_1fr] gap-4">
      <div className="text-small text-ink-2">{label}</div>
      <div className="text-table whitespace-pre-wrap break-words">{children ?? showValue(value)}</div>
    </div>
  );
}

export function SectionTitle({ children, note }: { children: ReactNode; note?: ReactNode }) {
  return (
    <div className="flex items-baseline justify-between gap-4 mt-6 mb-2 first:mt-0">
      <h3 className="font-serif font-semibold text-table">{children}</h3>
      {note ? <span className="text-small text-ink-2">{note}</span> : null}
    </div>
  );
}

export function Confidential() {
  return (
    <p className="text-small text-ink-2">
      Confidential to the selection committee. Do not copy applicant information out of the platform.
    </p>
  );
}
